import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { motion } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/pagination';
import VisualCanvas from './VisualCanvas';

const TestimonialsSection = () => {
    const testimonials = [
        {
            name: "Rajesh Kumar",
            role: "CEO, TechInnovate",
            text: "MehareTech transformed our legacy systems into a modern cloud-native architecture. Their expertise is unmatched in the industry.",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Rajesh"
        },
        {
            name: "Sneha Sharma",
            role: "Founder, BloomEd",
            text: "The mobile app they developed for us has seen tremendous user growth. The UI/UX is intuitive and beautiful.",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sneha"
        },
        {
            name: "Michael Chen",
            role: "CTO, Global Logistics",
            text: "Professional, timely, and highly skilled. They didn't just write code; they solved our complex business problems.",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Michael"
        }
    ];

    return (
        <section className="py-24 md:py-32 min-h-[auto] md:min-h-screen flex items-center bg-white transition-colors duration-500 relative overflow-hidden">
            {/* Subtle 3D Background */}
            <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none scale-150">
                <VisualCanvas type="torus" color="#2563eb" height="100%" />
            </div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-10 md:mb-16"
                >
                    <span className="text-primary font-black uppercase tracking-[0.4em] text-[10px] md:text-xs mb-3 block">Wall of Love</span>
                    <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight">Our Success <span className="text-gradient">Stories</span></h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={30}
                        slidesPerView={1}
                        breakpoints={{
                            768: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 }
                        }}
                        autoplay={{ delay: 5000 }}
                        pagination={{ clickable: true }}
                        className="pb-16 testimonial-swiper-light"
                    >
                        {testimonials.map((t, idx) => (
                            <SwiperSlide key={idx}>
                                <div className="bg-slate-50 p-6 md:p-10 rounded-[2rem] md:rounded-[2.5rem] border border-slate-100 h-full flex flex-col justify-between hover:shadow-xl hover:border-primary/20 transition-all duration-500 hover:-translate-y-2 group relative overflow-hidden">
                                    <div className="absolute top-0 right-0 w-24 h-24 bg-blue-500/5 rounded-full blur-3xl group-hover:bg-primary/10 transition-colors"></div>
                                    <div className="relative z-10">
                                        <div className="flex text-primary mb-4 text-base tracking-tighter">★★★★★</div>
                                        <p className="text-slate-600 font-medium italic leading-relaxed text-xs md:text-lg mb-8 group-hover:text-slate-900 transition-colors">"{t.text}"</p>
                                    </div>
                                    <div className="flex items-center gap-4 border-t pt-6 border-slate-200 relative z-10">
                                        <img src={t.avatar} alt={t.name} className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-primary/20 group-hover:scale-110 transition-all duration-500 shadow-md" />
                                        <div>
                                            <h4 className="font-black text-slate-900 text-xs md:text-lg tracking-tight">{t.name}</h4>
                                            <p className="text-[9px] md:text-[10px] text-primary font-black uppercase tracking-[0.2em] mt-1 opacity-80">{t.role}</p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </motion.div>
            </div>
        </section>
    );
};

export default TestimonialsSection;
